import classNames from 'classnames';
import { sharedMarkdownComponents } from 'components/organisms/AIChat/utils';
import type { FC } from 'react';
import ReactMarkdown from 'react-markdown';
import { useTranslation } from 'react-i18next';

type AIMessagePartPlaceholderProps = {
  messageId: string;
  isSmall?: boolean;
};

const AIMessagePartPlaceholder: FC<AIMessagePartPlaceholderProps> = ({
  messageId,
  isSmall,
}) => {
  const { t } = useTranslation();
  return (
    <div className={classNames({ 'text-sm': isSmall })}>
      <ReactMarkdown key={messageId} components={sharedMarkdownComponents}>
        {t('ai_bot.thinking.placeholder')}
      </ReactMarkdown>
    </div>
  );
};

export default AIMessagePartPlaceholder;
